import React, { useState, useEffect, useContext } from "react";
import DataTable from "../components/DataTableComponents";
import IconUI from "../components/iu/icon_ui";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { Tooltip } from "@mui/material";
import LoaderComponent from "../components/admin/LoaderComponent";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import {
  Box,
  Modal,
  TextField,
  // InputLabel,
  MenuItem,
  IconButton,
  InputAdornment,
  Autocomplete,
  // FormControl,
} from "@mui/material";
// import Select from "@mui/material/Select";
// import OutlinedInput from "@mui/material/OutlinedInput";
// import Chip from "@mui/material/Chip";
import { AiOutlineEdit, AiOutlineDelete } from "react-icons/ai";
import { maxLengthLimitInput } from "../utils/inputsRules";
import { services } from "../services/api";
import { NotificacionContext } from "../context/notificacion_context";

const Usuarios = () => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    border: "2px solid #661d40",

    boxShadow: 24,
    p: 4,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    overflowY: "scroll",
    height: 600,
    borderRadius: "40px",
    scrollbarWidth: "none",
  };

  const style2 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",

    border: "2px solid #661d40",
    boxShadow: 24,
    p: 4,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    overflowY: "scroll",
    height: "auto",
    borderRadius: "40px",
    scrollbarWidth: "none",
  };

  // const ITEM_HEIGHT = 48;
  // const ITEM_PADDING_TOP = 8;

  // const MenuProps = {
  //   PaperProps: {
  //     style: {
  //       maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
  //       width: 250,
  //     },
  //   },
  // };

  const ColorButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText("#005cbf"),
    backgroundColor: "#661d40",

    "&:hover": {
      backgroundColor: "#661d40",

    },
    borderRadius: "40px",
  }));

  const [state, setState] = useState({
    usuarios: [],
    usuarioSeleccionado: {},
    openModalCrear: false,
    openModalEditar: false,
    openModalEliminar: false,
  });

  // const [titulosState, setTitulos] = useState({
  //   data: [],
  // });

  const [areasState, setAreas] = useState({
    data: [],
  });

  // const permisos = [
  //   {
  //     id: 8,
  //     nombre: "SOLO_LECTURA",
  //   },
  //   {
  //     id: 1,
  //     nombre: "REGISTRO",
  //   },
  //   {
  //     id: 2,
  //     nombre: "BORRAR_ASUNTO",
  //   },
  //   {
  //     id: 3,
  //     nombre: "EXPORTACIÓN",
  //   },
  //   {
  //     id: 4,
  //     nombre: "RESTCOORDIVA",
  //   },
  //   {
  //     id: 5,
  //     nombre: "AUDIENCIA",
  //   },
  //   {
  //     id: 6,
  //     nombre: "EXPORTAR_AUDIENCIA",
  //   },
  //   {
  //     id: 7,
  //     nombre: "FIRMAR_DOCUMENTOS",
  //   },
  //   {
  //     id: 9,
  //     nombre: "REVISAR_DOCUMENTOS",
  //   },
  //   {
  //     id: 10,
  //     nombre: "GEOLOCALIZACION",
  //   },
  // ];

  const [formularioState, formularioSetState] = useState({
    nombre: "",
    usuario: "",
    telefono: "",
    email: "",
    permisos: [],
    password_desencriptada: "",
    cat_tipo_titulo_id: "",
    area_id: "",
    tipo_rol_id: "",
  });

  const [errors, setErrors] = useState({});

  const handleClickShowPassword = () => {
    setState({ ...state, showPassword: !state.showPassword });
  };

  const [loader, setLoader] = useState({
    loading: true,
  });

  const { showNotification } = useContext(NotificacionContext);

  const openModalCrear = () => {
    setState({ ...state, openModalCrear: true });
  };
  const handleCloseCrear = () => {
    setState({ ...state, openModalCrear: false });
    limpiarFormulario();
  };

  const openmodaleliminar = (data) => {
    const usuarioSeleccionado = {
      ...data,
      id: data.id ?? data.user?.id,
      name: data.name ?? data.user?.name ?? "",
    };
    setState({ ...state, openModalEliminar: true, usuarioSeleccionado });
  };

  const handleCloseEliminar = () => {
    setState({
      ...state,
      openModalEliminar: false,
    });
  };

  const roleNameMap = {
    ADMIN: 1,
    "PRIMER CONTACTO": 2,
    AREA: 3,
    ASESOR: 4,
    PSICOLOGO: 5,
  };

  const getRoleValue = (role, roles = []) => {
    if (role == null) {
      return roles?.[0]?.id ?? "";
    }
    if (typeof role === "number") {
      return role;
    }
    if (!Number.isNaN(Number(role))) {
      return Number(role);
    }
    const normalized = `${role}`.trim().toUpperCase();
    return roleNameMap[normalized] ?? roles?.[0]?.id ?? "";
  };

  const openModalEditar = (data) => {
    const usuarioSeleccionado = {
      ...data,
      id: data.id ?? data.user?.id,
      name: data.name ?? data.user?.name ?? "",
      email: data.email ?? data.user?.email ?? "",
      professional_document:
        data.professional_document ?? data.user?.professional_document ?? "",
      area_id:
        data.area_id ?? data.user?.area_id ?? data.user?.area?.id ?? null,
      role: getRoleValue(data.role, data.roles || data.user?.roles),
    };

    setState({ ...state, openModalEditar: true, usuarioSeleccionado });
    // setPermisos(data.permisos || []);
  };

  const handleCloseEditar = () => {
    setState({
      ...state,
      openModalEditar: false,
    });
    // setPermisos([]);
    setErrors({});
  };

  const usuariosTableData = (state.usuarios || []).map((usuario) => {
    const user = usuario.user || {};
    return {
      id: usuario.id ?? user.id ?? "",
      nombre: user.name ?? "",
      email: user.email ?? "",
      area: user.area?.name ?? "",
      role: usuario.role ?? "",
    };
  });

  const columns = [
    {
      name: "nombre",
      label: "NOMBRE",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          const nombre = usuariosTableData[dataIndex]?.nombre ?? "";
          return (
            <div
              className="d-flex align-items-center"
              style={{ height: "60px" }}
            >
              {nombre}
            </div>
          );
        },
      },
    },
    {
      name: "email",
      label: "CORREO",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          const titular = usuariosTableData[dataIndex]?.email ?? "";
          return (
            <div
              style={{ height: "60px" }}
              className="d-flex align-items-center"
            >
              {titular}
            </div>
          );
        },
      },
    },
    {
      name: "area",
      label: "AREA",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          const coordinador = usuariosTableData[dataIndex]?.area ?? "";
          return (
            <div
              style={{ height: "60px" }}
              className="d-flex align-items-center"
            >
              {coordinador}
            </div>
          );
        },
      },
    },
    {
      name: "role",
      label: "ROL",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          const rol = usuariosTableData[dataIndex]?.role ?? "";
          return (
            <div
              style={{ height: "60px" }}
              className="d-flex align-items-center"
            >
              {rol}
            </div>
          );
        },
      },
    },
    {
      name: "operaciones",
      label: "OPERACIONES",
      options: {
        filter: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => (
          <>
            <div
              style={{ height: "60px" }}
              className="text-decoration-underline d-flex align-items-center"
            >
              <Tooltip title="EDITAR USUARIO">
                <div
                  style={{ height: 30, width: 30, zIndex: 0 }}
                  className="cta cta--primary cta--icon icon_btn"
                  onClick={() => {
                    openModalEditar(state.usuarios[dataIndex]);
                  }}
                >
                  <IconUI size={"20px"} color={"black"}>
                    <AiOutlineEdit />
                  </IconUI>
                </div>
              </Tooltip>
              <Tooltip title="ELIMINAR USUARIO">
                <div
                  style={{ height: 30, width: 30, zIndex: 0 }}
                  className="cta cta--primary cta--icon icon_btn"
                  onClick={() => {
                    openmodaleliminar(state.usuarios[dataIndex]);
                  }}
                >
                  <IconUI size={"20px"} color={"black"}>
                    <AiOutlineDelete />
                  </IconUI>
                </div>
              </Tooltip>
            </div>
          </>
        ),
      },
    },
  ];

  const handleName = (e) => {
    formularioSetState({
      ...formularioState,
      name: e.target.value.toUpperCase(),
    });
  };
  const handleRole = (e) => {
    formularioSetState({ ...formularioState, role: Number(e.target.value) });
    // setPermisos([]);
  };
  const handleEmail = (e) => {
    formularioSetState({
      ...formularioState,
      email: e.target.value.toUpperCase(),
    });
  };
  const handleArea = (e) => {
    formularioSetState((formularioState) => ({
      ...formularioState,
      area_id: e ? e.id : null,
    }));
  };
  const handleProfessional_document = (e) => {
    formularioSetState({
      ...formularioState,
      professional_document: e.target.value.toUpperCase(),
    });
  };

  // const [permisosState, setPermisos] = useState([]);

  // const handleChangePermisos = (event) => {
  //   const {
  //     target: { value },
  //   } = event;
  //   setPermisos(

  //     typeof value === "string" ? value.split(",") : value,
  //   );
  // };

  const handleSeleccionadoName = (e) => {
    setState({
      ...state,
      usuarioSeleccionado: {
        ...state.usuarioSeleccionado,
        name: e.target.value,
      },
    });
  };
  const handleSeleccionadoRole = (e) => {
    setState({
      ...state,
      usuarioSeleccionado: {
        ...state.usuarioSeleccionado,
        role: Number(e.target.value),
      },
    });
  };
  const handleSeleccionadoEmail = (e) => {
    setState({
      ...state,
      usuarioSeleccionado: {
        ...state.usuarioSeleccionado,
        email: e.target.value,
      },
    });
  };
  const handleSeleccionadoPass = (e) => {
    setState({
      ...state,
      usuarioSeleccionado: {
        ...state.usuarioSeleccionado,
        password_desencriptada: e.target.value,
      },
    });
  };
  // const handleSeleccionadoChange = (event) => {
  //   const {
  //     target: { value },
  //   } = event;
  //   setPermisos(

  //     typeof value === "string" ? value.split(",") : value,
  //   );
  // };
  const handleSeleccionadoArea = (e) => {
    setState({
      ...state,
      usuarioSeleccionado: {
        ...state.usuarioSeleccionado,
        area_id: e ? e.id : null,
      },
    });
  };
  const handleSeleccionadoProfessional_document = (e) => {
    setState({
      ...state,
      usuarioSeleccionado: {
        ...state.usuarioSeleccionado,
        professional_document: e.target.value,
      },
    });
  };

  const regexEmail = /^[^\s@]{1,64}@[^\s@]{1,255}\.[^\s@]{2,24}$/;

  const validarFormulario = () => {
    let newErrors = {};
    if (!formularioState.name) {
      newErrors.name = "Este Campo es Requerido";
    }
    if (!formularioState.area_id) {
      newErrors.area_id = "Este Campo es Requerido";
    }
    if (!formularioState.role) {
      newErrors.role = "Este Campo es Requerido";
    }
    if (!formularioState.email) {
      newErrors.email = "Este Campo es Requerido";
    }
    if (formularioState.role === 2 && !formularioState.professional_document) {
      newErrors.professional_document = "Este Campo es Requerido";
      showNotification(
        "error",
        "Ups... ",
        "Favor de Agregar al menos un permiso",
        null,
        4,
      );
    }

    // if (
    //   formularioState.telefono !== "" &&
    //   formularioState.telefono.length < 10
    // ) {
    //   newErrors.telefono = "Favor poner un número de 10 dígitos";
    // }
    if (formularioState.email !== "") {
      let valido = regexEmail.test(formularioState.email);
      if (!valido) {
        newErrors.email = "Ingrese un email válido";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validarEditar = () => {
    let newErrors = {};

    if (!state.usuarioSeleccionado.name) {
      newErrors.name = "Este Campo es Requerido";
    }

    if (!state.usuarioSeleccionado.area_id) {
      newErrors.area_id = "Este Campo es Requerido";
    }

    if (!state.usuarioSeleccionado.role) {
      newErrors.role = "Este Campo es Requerido";
    }

    if (state.usuarioSeleccionado.email !== "") {
      let valido = regexEmail.test(state.usuarioSeleccionado.email);

      if (!valido) {
        newErrors.email = "Ingrese un email válido";
      }
    } else {
      newErrors.email = "Este Campo es Requerido";
    }

    // Validación de password (solo si se captura)
    const password = state.usuarioSeleccionado.password_desencriptada;

    if (password) {
      if (password.length < 10) {
        newErrors.password_desencriptada =
          "La contraseña debe tener al menos 10 caracteres";
      } else if (!/[A-Z]/.test(password)) {
        newErrors.password_desencriptada =
          "La contraseña debe contener al menos una letra mayúscula";
      } else if (!/[a-z]/.test(password)) {
        newErrors.password_desencriptada =
          "La contraseña debe contener al menos una letra minúscula";
      } else if (!/[\W_]/.test(password)) {
        newErrors.password_desencriptada =
          "La contraseña debe contener al menos un carácter especial";
      }
    }

    if (
      state.usuarioSeleccionado.role === 2 &&
      !state.usuarioSeleccionado.professional_document
    ) {
      newErrors.professional_document = "Este Campo es Requerido";

      showNotification(
        "error",
        "Ups...",
        "Favor de Agregar al menos un permiso",
        null,
        4
      );
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const mostrarUsuarios = async () => {
    setLoader({ ...loader, loading: true });
    let usuarios = await services({
      method: "GET",
      service: `user`,
      body: null,
    });
    let areas = await services({
      method: "GET",
      service: `areas`,
      body: null,
    });

    if (
      usuarios.status === 200 &&
      areas.status === 200
    ) {
      setState({ ...state, usuarios: usuarios.data });
      setAreas({ ...areasState, data: areas.data });
      setLoader({ ...loader, loading: false });
    } else {
      setLoader({ ...loader, loading: false });
      showNotification(
        "error",
        "Usuarios",
        "No se han podido cargar los usuarios",
        null,
        4,
      );
    }
  };

  const limpiarFormulario = () => {
    formularioSetState({
      ...formularioState,
      name: "",
      // usuario: "",
      // apellido_paterno: "",
      // apellido_materno: "",
      // telefono: "",
      email: "",
      area_id: "",
      role: "",
      professional_document: "",
    });
    // setPermisos([]);
  };

  const crearUsuario = async () => {
    setLoader({ ...loader, loading: true });
    if (validarFormulario()) {
      const usuario = await services({
        method: "POST",
        service: "register",
        body: {
          name: formularioState.name,
          email: formularioState.email,
          area_id: formularioState.area_id,
          role: formularioState.role,
          // permisos: permisosState,
          professional_document: formularioState.professional_document,
          
        },
      });
      if (usuario.status === 201) {
        const usuarios = await services({
          method: "GET",
          service: `user`,
          body: null,
        });
        if (usuarios.status === 200) {
          setState({
            ...state,
            usuarios: usuarios.data,
            openModalCrear: false,
          });
          limpiarFormulario();
          showNotification(
            "success",
            "Usuario",
            "Se ha Agregado con Éxito",
            null,
            4,
          );
          setLoader({ ...loader, loading: false });
        } else {
          setLoader({ ...loader, loading: false });
          showNotification(
            "error",
            "Ups... Algo sucedió",
            usuarios.data.message,
            null,
            4,
          );
        }
      } else {
        showNotification(
          "error",
          "Ups... Algo sucedió",
          usuario.data.message,
          null,
          4,
        );
        handleCloseCrear();
        setLoader({ ...loader, loading: false });
        limpiarFormulario();
      }
    } else {

      showNotification(
        "error",
        "ups...Error ",
        "Por favor llena todos los campos",
        null,
      );
      setLoader({ ...loader, loading: false });
    }
  };

  const editarUsuario = async () => {
    setLoader({ ...loader, loading: true });
    if (validarEditar()) {
      const usuario = await services({
        method: "PUT",
        service: `user/${state.usuarioSeleccionado.id}`,
        body: {
          name: state.usuarioSeleccionado.name?.toUpperCase(),
          email: state.usuarioSeleccionado.email?.toUpperCase(),
          area_id: state.usuarioSeleccionado.area_id,
          role: state.usuarioSeleccionado.role,
          professional_document: state.usuarioSeleccionado.professional_document.toUpperCase(),
          ...(state.usuarioSeleccionado.password_desencriptada && {
            password: state.usuarioSeleccionado.password_desencriptada,
          }),
          // permisos: permisosState,
        },
      });
      if (usuario.status === 200) {
        const usuarios = await services({
          method: "GET",
          service: `user`,
          body: null,
        });
        if (usuarios.status === 200) {
          setState({
            ...state,
            usuarios: usuarios.data,
            openModalEditar: false,
          });
          showNotification("success", "Usuario", "Editado con Éxito", null, 4);
          setLoader({ ...loader, loading: false });
        } else {
          showNotification(
            "error",
            "Ups... Algo Sucedió",
            "Error al Editar Usuario",
            null,
            4,
          );
          setState({ ...state, openModalEditar: false });
          setLoader({ ...loader, loading: false });
        }
      } else {
        setLoader({ ...loader, loading: false });

        setState({ ...state, openModalEditar: false });
        showNotification(
          "error",
          "Ups... Algo Sucedió",
          "Error al Editar Usuario",
          null,
          4,
        );
      }
    } else {
      showNotification(
        "error",
        "Favor de Revisar",
        "Los campos selecionados",
        null,
        4,
      );
      setLoader({ ...loader, loading: false });
    }
  };

  const eliminarUsuario = async () => {
    setLoader({ ...loader, loading: true });
    const eliminar = await services({
      method: "DELETE",
      service: `user/${state.usuarioSeleccionado.id}`,
      body: null,
    });
    if (eliminar.status === 200) {
      let usuarios = await services({
        method: "GET",
        service: `user`,
        body: null,
      });
      if (usuarios.status === 200) {
        setState({
          ...state,
          usuarios: usuarios.data,
          openModalEliminar: false,
        });
        showNotification("success", "Usuario", "Eliminado con Éxito", null, 4);
        setLoader({ ...loader, loading: false });
      } else {
        setLoader({ ...loader, loading: false });

        setState({ ...state, openModalEliminar: false });
        showNotification(
          "error",
          "ups... Algo sucedió",
          "Error al Eliminar Usuario",
          null,
          4,
        );
      }
    } else {
      setLoader({ ...loader, loading: false });
      setState({ ...state, openModalEliminar: false });
      showNotification(
        "error",
        "ups... Algo sucedió",
        "Error al Eliminar Usuario",
        null,
        4,
      );
    }
  };

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      mostrarUsuarios();
    }

    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div className=" justify-content-center align-items-start py-4">
        {loader.loading && <LoaderComponent />}
        <div className="container">
          <Grid
            sx={{ marginTop: 3 }}
            container
            justifyContent="flex-end"
            alignItems="flex-end"
            spacing={2}
          >
            <Grid item>
              <ColorButton
                startIcon={<AddCircleOutlineIcon />}
                onClick={() => {
                  openModalCrear();
                }}
              >
                AÑADIR NUEVO USUARIO
              </ColorButton>
            </Grid>
          </Grid>
        </div>
        <DataTable
          data={usuariosTableData}
          title={`TABLA DE USUARIOS`}
          columns={columns}
        />

        <Modal
          open={state.openModalCrear}
          onClose={() => handleCloseCrear()}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="contenedorModalUrs" sx={style}>
            <h3 className="TitulosProgramas">NUEVO USUARIO</h3>
            <Grid container columns={12} spacing={3}>
              <Grid item xs={12}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-name"
                  label="NOMBRE"
                  variant="outlined"
                  error={!!errors.name}
                  helperText={errors.name || ""}
                  value={formularioState.name}
                  onChange={handleName}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-TipoUsuario"
                  label="TIPO DE USUARIO"
                  variant="outlined"
                  select
                  error={!!errors.role}
                  helperText={errors.role || ""}
                  value={formularioState.role}
                  onChange={handleRole}
                >
                  <MenuItem value={1}>ADMINISTRADOR</MenuItem>
                  <MenuItem value={2}>PRIMER CONTACTO</MenuItem>
                  <MenuItem value={3}>AREA</MenuItem>
                  <MenuItem value={4}>ASESOR</MenuItem>
                  <MenuItem value={5}>PSICOLOGO</MenuItem>
                  <MenuItem value={6}>LECTURA</MenuItem>

                </TextField>
              </Grid>
              {/* {formularioState.tipo_rol_id === 2 ? (
                <Grid item xs={12}>
                  <FormControl fullWidth size="small">
                    <InputLabel>PERMISOS</InputLabel>
                    <Select
                      multiple
                      value={permisosState}
                      onChange={handleChangePermisos}
                      error={!!errors.permisos}
                      input={
                        <OutlinedInput
                          id="select-multiple-chip"
                          label="PERMISOS"
                        />
                      }
                      renderValue={(selected) => (
                        <Box
                          sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}
                        >
                          {selected.map((value) => (
                            <Chip key={value} label={value} />
                          ))}
                        </Box>
                      )}
                      MenuProps={MenuProps}
                    >
                      {permisos.map((item) => (
                        <MenuItem key={item.id} value={item.nombre}>
                          {item.nombre}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              ) : (
                <></>
              )} */}
              <Grid item xs={12}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-correo"
                  label="CORREO"
                  variant="outlined"
                  error={!!errors.email}
                  helperText={errors.email || ""}
                  value={formularioState.email}
                  onChange={handleEmail}
                  onKeyPress={(event) => {
                    maxLengthLimitInput(event, 55, "email");
                  }}
                />
              </Grid>
              {/* <h5 className="ms-4 mt-3">AREA</h5> */}
              <Grid item xs={12}>
                <Autocomplete
                  options={areasState.data || []}
                  getOptionLabel={(option) => option.name}
                  fullWidth
                  size="small"
                  id="textFile-area"
                  sx={{ borderRadius: "30px" }}
                  value={
                    areasState.data.find(
                      (option) => option.id === formularioState.area_id,
                    ) || null
                  }
                  onChange={(event, newValue) => handleArea(newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      required
                      variant="outlined"
                      label="AREAS"
                      error={!!errors.area_id}
                      helperText={errors.area_id || ""}
                    />
                  )}
                />
              </Grid>

              {formularioState.role === 2 ? (
                <Grid item xs={12}>
                  <TextField
                    required
                    sx={{ borderRadius: "30px" }}
                    fullWidth
                    size="small"
                    id="textFile-professional_document"
                    label="CÉDULA PROFESIONAL"
                    variant="outlined"
                    error={!!errors.professional_document}
                    helperText={errors.professional_document || ""}
                    onChange={handleProfessional_document}
                    value={formularioState.professional_document}
                    // onKeyPress={onlyNumber}
                    // inputProps={{ maxLength: 10 }}
                  />
                </Grid>
              ) : (
                <></>
              )} 

              <Grid marginLeft="auto" item>
                <ColorButton
                  sx={{ backgroundColor: "#6A0F49" }}
                  onClick={() => {
                    crearUsuario();
                  }}
                >
                  Guardar
                </ColorButton>
              </Grid>
            </Grid>
          </Box>
        </Modal>

        <Modal
          open={state.openModalEditar}
          onClose={handleCloseEditar}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="contenedorModalUrs" sx={style}>
            <h3 className="TitulosProgramas">EDITAR USUARIO</h3>
            <Grid container columns={12} spacing={3}>
              <Grid item xs={12}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-nombre"
                  label="NOMBRE"
                  variant="outlined"
                  error={!!errors.name}
                  helperText={errors.name || ""}
                  value={state.usuarioSeleccionado.name || ""}
                  onChange={handleSeleccionadoName}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-TipoUsuario"
                  label="TIPO DE USUARIO"
                  variant="outlined"
                  select
                  error={!!errors.role}
                  helperText={errors.role || ""}
                  value={state.usuarioSeleccionado.role}
                  onChange={handleSeleccionadoRole}
                >
                  <MenuItem value={1}>ADMINISTRADOR</MenuItem>
                  <MenuItem value={2}>PRIMER CONTACTO</MenuItem>
                  <MenuItem value={3}>AREA</MenuItem>
                  <MenuItem value={4}>ASESOR</MenuItem>
                  <MenuItem value={5}>PSICOLOGO</MenuItem>
                  <MenuItem value={6}>LECTURA</MenuItem>
                </TextField>
              </Grid>
              {/* {state.usuarioSeleccionado.tipo_rol_id === 2 ? (
                <Grid item xs={12}>
                  <FormControl fullWidth size="small">
                    <InputLabel>PERMISOS</InputLabel>
                    <Select
                      multiple
                      value={permisosState}
                      onChange={handleSeleccionadoChange}
                      error={!!errors.permisos}
                      input={
                        <OutlinedInput
                          id="select-multiple-chip"
                          label="PERMISOS"
                        />
                      }
                      renderValue={(selected) => (
                        <Box
                          sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}
                        >
                          {selected.map((value) => (
                            <Chip key={value} label={value} />
                          ))}
                        </Box>
                      )}
                      MenuProps={MenuProps}
                    >
                      {permisos.map((item) => (
                        <MenuItem key={item.id} value={item.nombre}>
                          {item.nombre}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              ) : (
                <></>
              )} */}
              <Grid item xs={12}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-correo"
                  label="CORREO"
                  variant="outlined"
                  error={!!errors.email}
                  helperText={errors.email || ""}
                  value={state.usuarioSeleccionado.email || ""}
                  onChange={handleSeleccionadoEmail}
                  onKeyPress={(event) => {
                    maxLengthLimitInput(event, 55, "email");
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  label="CONTRASEÑA"
                  variant="outlined"
                  type={state.showPassword ? "text" : "password"}
                  error={!!errors.password_desencriptada}
                  helperText={errors.password_desencriptada || ""}
                  value={state.usuarioSeleccionado.password_desencriptada || ""}
                  onChange={handleSeleccionadoPass}
                  placeholder="Dejar vacío para mantener la contraseña actual"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                        >
                          {state.showPassword ? (
                            <VisibilityOff />
                          ) : (
                            <Visibility />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            
              <Grid item xs={12}>
                <Autocomplete
                  options={areasState.data || []}
                  getOptionLabel={(option) => option.name || ""}
                  fullWidth
                  size="small"
                  id="textFile-area"
                  sx={{
                    borderRadius: "30px",
                  }}
                  value={
                    areasState.data.find(
                      (option) =>
                        Number(option.id) ===
                        Number(state.usuarioSeleccionado.area_id ?? state.usuarioSeleccionado.user?.area_id),
                    ) || null
                  }
                  onChange={(event, newValue) =>
                    handleSeleccionadoArea(newValue)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      required
                      variant="outlined"
                      label="AREAS"
                      error={!!errors.area_id}
                      helperText={errors.area_id || ""}
                    />
                  )}
                />
              </Grid>

              {state.usuarioSeleccionado.role === 2 ? (
                <Grid item xs={12}>
                  <TextField
                    required
                    sx={{ borderRadius: "30px" }}
                    fullWidth
                    size="small"
                    id="textFile-professional_document"
                    label="CÉDULA PROFESIONAL"
                    variant="outlined"
                    error={!!errors.professional_document}
                    helperText={errors.professional_document || ""}
                    value={state.usuarioSeleccionado.professional_document || ""}
                    onChange={handleSeleccionadoProfessional_document}
      
                  />
                </Grid>
              ) : (
                <></>
              )} 

              <Grid marginLeft="auto" item>
                <ColorButton
                  onClick={() => {
                    editarUsuario();
                  }}
                >
                  Editar
                </ColorButton>
              </Grid>
            </Grid>
          </Box>
        </Modal>

        <Modal
          open={state.openModalEliminar}
          onClose={handleCloseEliminar}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="contenedorModalUrs text-center" sx={style2}>
            <h3 className="TitulosProgramas  mb-5">
              ¿Está Seguro de Eliminar al Usuario?
            </h3>
            <Grid container columns={12} spacing={4}>
              <Grid item xs={12}>
                <h4>{state.usuarioSeleccionado.name}</h4>
              </Grid>

              <Grid margin="auto" item>
                <ColorButton
                  onClick={() => {
                    eliminarUsuario();
                  }}
                >
                  Si, Eliminar
                </ColorButton>
              </Grid>
            </Grid>
          </Box>
        </Modal>
      </div>
    </>
  );
};

export default Usuarios;
